export const fieldLabels = {
  caseTitle: "Case title",
  dateAssigned: "Date assigned",
  summary: "Summary",
  directorate: "Directorate",
  duration: "Duration",
  team: "Team",
  requested: "Requested",
  matterType: "Matter type/ Area of work",
  category: "Category",
  subCategory: "Sub category",
  dueDate: "Due date",
  assingedTo: "Assigned to",
  lineManager: "Line Manager",
  awardginOrg: "Add AOs",
  awardingOrgContactName: "Contact name",
  awardingOrgEmail: "Contact email",
  taggingSummary: "Summary of advice received",
  taggingReceivedFrom: "Received from",
  taggingKeywords: "Keywords",
  sensitive: "Sensitive",
  name: "Name",
  email: "Email address",
  note: "Notes",
  counselCategory: "Counsel Category",
  forecast: "Forecast",
  requestExternalCounselName: "Counsel name",
  externalCounsel: "External counsel",
  caseNoteType: "Case note type",
  caseNote: "Case note",
  date: "Date",
  caseNoteMeetingDate: "Meeting date",
  caseNoteFiles: "Files",
  caseCloseType: "Close type",
  closeTypeClose: "Close",
  closeTypeCancel: "Cancel",
  dateAndTime: "Date and time",
  meansOfCommunication: "Means of communication",
  title: "Qualification title",
  organisationReferenceNumber: "Organisation qualification reference",
  linkToSpecification: "Link to specification",
  qualLevel: "Qualification level",
  qualSubLevel: "Qualification sub-level",
  qualificationType: "Qualification type",
  epaStandardId: "EPA standard code",
  qualGLH: "GLH",
  qualTQT: "TQT",
  qualCredit: "Credit",
  qualSectorSubjectArea: "Sector subject area",
  overallGradingType: "Overall grading type",
  gradingScale: "Grading scale",
  qualAssessmentMethods: "Assessment methods",
  specialism: "Specialism",
  operationalStartDate: "Operational start date",
  qualificationReviewDate: "Qualification review date",
  operationalEndDate: "Operational end date",
  certificationEndDate: "Certification end date",
  offeredInEngland: "Offered in England",
  offeredInNorthernIreland: "Offered in Northern Ireland",
  preSixteen: "Pre 16",
  sixteenToEighteen: "16-18",
  eighteenPlus: "18+",
  nineteenPlus: "19+",
  fundingInEngland: "Intention to seek funding in England",
  fundingInNorthernIreland: "Intention to seek funding in Northern Ireland",
  isThisQualificationPrivate: "Is this qualification private?",
  optionalRoutesToCompleteQual: "Optional routes to complete qualification",
  offeredInternationally:
    "Currently offering and/or will consider offering internationally",
  niDiscountCode: "NI discount code",
  entitlementFrameworkDesignation: "Entitlement Framework (EF) Designation",
  gcseSizeEquivalence: "GCSE size equivalence",
  gceSizeEquivalence: "GCE size equivalence",
  approvedForDELFundedProgramme:
    "Approved for Department for the Economy funded programme",

  policyCategory: "Policy Category",
  createdDate: "Created Date",
  modifiedDate: "Modified Date",
  createdUpn: "Created Upn",
  createdByDisplayName: "Created By Display Name",
  modifiedbyUpn: "Modified by Upn",
  referenceNumber: "Reference Number",
  assignedCreatedDate: "Date Assigned",
  status: "Status",
  requestedBy: "Requested By",
  lineManagerUpn: "Line Manager Upn",
  lineManagerDisplayName: "Line Manager Display Name",
  counselTelephone: "Counsel Telephone",
  counselEmail: "Counsel Email",
  counselTags: "Counsel Tags",
  counselSummaryAdvice: "Counsel Summary Advice",
  counselReceivedFrom: "Counsel Received From",
  counselKeywords: "Counsel Keywords",
  assignedTo: "Assigned To",
  policySubCategory: "Policy Sub Category",
  keywordId: "Keyword Id",
  awardingOrg: "Awarding Organisation",
};
